import Popup from '@root/core/components/Popup';
import useDebounce from '@root/core/hooks/useDebounce';
import ReturnServices from '@root/modules/Sellers/Return/services/return';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import { Button, Checkbox, message, Spin } from 'antd';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import moment from 'moment';
import { Item } from 'rc-menu';
import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import InfoProReturn from '../components/InfoProduct';
import Recipient from '../components/Recipient/Recipient';
import Product from '../components/ReturnDetail/Product';

interface Props {
  tab?: string;
}

const CancelOrder = ({ tab }: Props) => {
  const [openReject, setOpenReject] = useState(false);
  const [openApprove, setOpenApprove] = useState(false);
  const [value, setValue] = useState('');
  const [options, setOptions] = useState<{ value: string }[]>([]);
  const debounc = useDebounce(value, 1000);
  const [showAdd, setShowAdd] = useState(false);
  const [idOrder, setIdOrder] = useState([] as any);
  const [listProOrder, setListProOrder] = useState([] as any);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const [productId, setProductId] = useState(0);
  const [getBody, setGetBody] = useState<any>();
  const [destroy, setDestroy] = useState('');

  const onSearch = async (searchText: any) => {
    setOptions([]);
    const listId = await ReturnServices.searchOrderCanReturn(searchText);

    if (listId) {
      let a = listId.data.map((item: any, index: number) => {
        return {
          value: item.orderNumber,
          key: item.id,
          label: (
            <div
              key={index + 200}
              onClick={() => {
                setProductId(item.id);
              }}
            >
              {item.orderNumber}
            </div>
          )
        };
      });
      setOptions(listId.data.length > 0 ? a : []);
    }
  };

  useEffect(() => {
    onSearch(value);
  }, [debounc]);

  const onChange = async (data: string) => {
    setValue(data);
    if (!data) {
      setShowAdd(false);
      setListProOrder([]);
      setIdOrder([]);
      setProductId(0);
    }
  };

  useEffect(() => {
    onSelect();
  }, [productId]);

  const onSelect = async () => {
    if (productId !== 0) {
      const quoteDetail = await ReturnServices.getListOrderProduct(productId);
      const list: any[] = [];
      const arrData: any[] = quoteDetail?.data?.orderProducts;
      arrData.forEach((item: any, index: number) => {
        list.push({
          productName: item.productImported.productName,
          sku: item.productImported.sku,
          eanUpc: item.productImported.eanUpc,
          quantity: item.orderQuantity,
          productId: item.productImportedId
        });
      });
      setIdOrder(quoteDetail.data);
      setListProOrder(list);
      let na = list.map((item: any) => ({
        productId: item.productId,
        value: item.quantity
      }));
      setProduct(na);
    }
  };

  /*---------------------------------------return--------------------------*/
  const [idPros, setIdPros] = useState([] as any);
  const [shippAdd, setShippAdd] = useState([] as any);
  const [product, setProduct] = useState<
    { productId: string; value: string }[] | null
  >(null);
  useEffect(() => {
    setShippAdd('');
  }, [shippAdd]);

  useEffect(() => {}, [product]);
  /*---get checkbox----*/
  const onChangeCheck = (checkedValues: CheckboxValueType[]) => {
    const list: any[] = [];
    list.push({ checkedValues });
    setIdPros(list);
  };

  /*---------------handle ok-------------------*/

  const handleOKReturn = async (value: any) => {
    setOpenReject(false);
    setOpenApprove(false);
    setLoading(true);

    try {
      const quoteDetail = await ReturnServices.postCreateOrder(getBody);
      setLoading(false);
      if (quoteDetail.massage === 'success') {
        message.success(
          getBody.processType === 'return'
            ? 'Add return order success!'
            : 'Add return disposal success!'
        );
        history.push(
          getBody.processType === 'return'
            ? '/admin/seller/shipping/return-request'
            : '/admin/seller/shipping/return-disposal'
        );
      }
    } catch (err) {
      setLoading(false);

      message.error(
        getBody.processType === 'return'
          ? 'Cant add return order !'
          : 'Cant add return disposal !'
      );
    }
  };

  const childRef: any = useRef();

  useEffect(() => {
    let locat: any = history.location.state;
    if (!!locat && !!locat.idOrder) {
      setValue(locat?.idOrder);
      setProductId(locat?.idOrder);
      setOptions([]);
    }
  }, [history]);

  return (
    <div className="cancelOrder">
      <Spin spinning={loading}>
        <InfoProReturn
          canInput
          value={value}
          onChange={onChange}
          options={options}
          onSelect={onSelect}
          orderDate={formatDateTime(idOrder?.orderDate || '')}
          buyerName={idOrder.buyerName}
          recipientName={idOrder.recipientName}
          buyerEmail={idOrder.buyerEmail}
          recipientPhone={idOrder.recipientPhone}
          street={idOrder.shippingAddress}
          shippingAddress={idOrder.shippingAddress}
          detailAddress={idOrder.detailAddress}
          detailAddress2={idOrder.detailAddress2}
          postalCode={idOrder.postalCode}
          country={idOrder.country}
          city={idOrder.city}
          state={idOrder.state}
          saleChannel={idOrder.saleChannel}
        />
        <div
          style={{
            paddingTop: '20px',
            borderBottom: '1px solid #ebecef'
          }}
        >
          <Checkbox.Group style={{ width: '100%' }} onChange={onChangeCheck}>
            {listProOrder.length !== 0 ? (
              <>
                {listProOrder.map((item: any, index: number) => (
                  <Product
                    id={item.productId}
                    haveCheck
                    productName={item.productName || 'gs'}
                    sku={item.sku}
                    eanUpc={item.eanUpc}
                    quantity={item.quantity}
                    onchange1={(e) => {
                      let a = Array.isArray(product)
                        ? product.findIndex(
                            (itemUse) => itemUse.productId == item.productId
                          )
                        : -1;
                      if (a == -1 && !!Array.isArray(product))
                        setProduct((old: any) => {
                          return [
                            ...old,
                            { productId: item.productId, value: e }
                          ];
                        });
                      else if (a !== -1) {
                        let n: any = product;
                        n[a] = { productId: item.productId, value: e };
                        setProduct(n);
                      } else {
                        setProduct([{ productId: item.productId, value: e }]);
                      }
                    }}
                  />
                ))}
              </>
            ) : (
              <>
                <Product />
              </>
            )}
          </Checkbox.Group>
        </div>
      </Spin>
      <div>
        <Recipient
          notQuan
          canEdit
          product={product}
          recipientName={idOrder?.warehouse?.name}
          recipientPhone={idOrder?.warehouse?.phoneNumber}
          state={idOrder?.warehouse?.state}
          postalCode={idOrder?.warehouse?.postalCode}
          country={idOrder?.warehouse?.country}
          city={idOrder?.warehouse?.city}
          detailReturnAddress={idOrder?.warehouse?.detailAddress}
          detailReturnAddress2={idOrder?.warehouse?.detailAddress2}
          setShippAdd={setShippAdd}
          ref={childRef}
          tab={tab}
          idPros={idPros}
          entityId={productId}
          getBody={setGetBody}
          setOpenReject={setOpenReject}
          setOpenApprove={setOpenApprove}
          setDestroy={setDestroy}
        />
      </div>

      <Popup
        styleBackground="white"
        styleColor="#2A2D51"
        visible={openReject}
        textCancel="취소"
        textOk="확인"
        title="반품 요청 하시겠습니까?"
        action_oke={handleOKReturn}
        action_cancel={() => {
          setOpenReject(false);
          // history.push('/admin/seller/return');
        }}
      />
      <Popup
        styleBackground="white"
        styleColor="#2A2D51"
        visible={openApprove}
        textCancel="취소"
        textOk="확인"
        title="폐기 요청 하시겠습니까?"
        action_oke={handleOKReturn}
        action_cancel={() => {
          setOpenApprove(false);
          // history.push('/admin/seller/return-disposal');
        }}
      />
    </div>
  );
};

export default CancelOrder;
